import { ICommonSettings, IPasswordPolicy } from "@kuika/kuika-cl-model";
import { PureComponent, ReactNode } from "react";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "../app-settings-config-container";
import { ConfigSettingSelect } from "../config-setting-select";
import { ConfigPasswordPolicy, PASSWORD_POLICY_SEARCH_TERMS } from "./app-settings-config-password-policy";

export interface IConfigPasswordsInputState {
  showModal: boolean;
  editingPasswordPolicyId: string | null;
}

export interface IConfigPasswordsInputProps {
  parentConfigValue?: string | null;
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput?: (formItemName: string[], value: string | null) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
}

export class ConfigPasswordsInput extends PureComponent<IConfigPasswordsInputProps, IConfigPasswordsInputState> {
  formInputName = ["apiConfig", "passwordPoliciesId"];

  constructor(props: IConfigPasswordsInputProps) {
    super(props);
    this.state = {
      showModal: false,
      editingPasswordPolicyId: null
    };
  }

  openModal = () => {
    this.setState({ showModal: true, editingPasswordPolicyId: "" });
  };

  closeModal = () => {
    this.setState({ showModal: false });
  };

  setEditingPasswordPolicy = (id: string | null) => {
    this.setState({ editingPasswordPolicyId: id, showModal: true });
  };

  handleRestore = (): void => {
    this.props.handleUpdateCustomFormInput?.(this.formInputName, this.props.parentConfigValue ?? null);
  };

  render() {
    const {
      parentConfigValue,
      commonSettings,
      getSectionDescription,
      handleUpdateCustomFormInput,
      handleCreateCommonConfig,
      handleUpdateCommonConfig,
      handleDeleteCommonConfig
    } = this.props;

    const optionsList = [
      { id: null, name: "Default" } as unknown as IPasswordPolicy,
      ...(commonSettings.passwordPolicies || [])
    ];

    return (
      <>
        <ConfigPasswordPolicy
          formInputName={this.formInputName}
          closeModal={this.closeModal}
          showModal={this.state.showModal}
          editingPolicyId={this.state.editingPasswordPolicyId}
          commonSettings={commonSettings}
          getSectionDescription={getSectionDescription}
          handleCreateCommonConfig={handleCreateCommonConfig}
          handleUpdateCommonConfig={handleUpdateCommonConfig}
          handleDeleteCommonConfig={handleDeleteCommonConfig}
        />
        <ConfigSettingSelect
          searchTerms={PASSWORD_POLICY_SEARCH_TERMS}
          label="Password policy"
          formInputName={this.formInputName}
          options={optionsList}
          tooltipContentKey="appsettings_authentication_authorization_passwordpolicy"
          onAddNew={this.openModal}
          onEdit={this.setEditingPasswordPolicy}
          parentConfigValue={this.props.parentConfigValue}
          onRestore={this.handleRestore}
          dropdownTestId="appSettingsAuthPasswordPolicyDropdown"
          addNewTestId="appSettingsAuthPasswordPolicyAddNew"
          editTestId="appSettingsAuthPasswordPolicyEditButton"
        />
      </>
    );
  }
}
